type MainContentProps = {
  children: React.ReactNode;
};

export default function MainContent({ children }: MainContentProps) {
  return (
    <div className="bg-white rounded-[12px] w-full md:max-w-[633px]">
      {children}
    </div>
  );
}
